import { render, staticRenderFns } from "./DataConfirmation.vue?vue&type=template&id=e818effc&scoped=true"
import script from "./DataConfirmation.vue?vue&type=script&lang=js"
export * from "./DataConfirmation.vue?vue&type=script&lang=js"
import style0 from "./DataConfirmation.vue?vue&type=style&index=0&id=e818effc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e818effc",
  null
  
)

export default component.exports